
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rims/transportbil/overlanding",
      function () {
        return require("private-next-pages/rims/transportbil/overlanding.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rims/transportbil/overlanding"])
      });
    }
  